import closest from 'closest'

import { Consent, userHasOptedOutOfCookiesForCategory } from './consent'
import { allDomains } from '../constants/siteList'
import ga from './ga'
import domLoaded from './domLoaded'
import { getConfigBySite } from '../../config/sites'
import getCurrentSiteByUrl from '../../server/lib/getCurrentSiteByUrl'
import { removeCookie } from './cookieHelper'

const removeTrackerStorage = () => {
  // using the global GA variable instead of our wrapped one
  const GA_LOCAL_STORAGE_KEY = 'ga:clientId'
  const currentSite = getCurrentSiteByUrl(document.location.hostname)
  const trackingId = getConfigBySite(currentSite, 'google_analytics_id')
  const path = '/'

    // Explicity disable GA as per documentation as an extra precaution
    // https://developers.google.com/analytics/devguides/collection/gtagjs/user-opt-out
  ;(window as any)[`ga-disable-${trackingId}`] = true

  // Manually delete any existing GA cookies (_ga, _gat, _gat_XXX, _gid)
  ;['_ga', '_gid', '_gat'].forEach(cookieName =>
    removeCookie({ itemKey: cookieName, cookieOptions: { path } })
  )

  // remove localStorage
  localStorage.removeItem(GA_LOCAL_STORAGE_KEY)
}

const handleCookiebotAcceptDeclineEvent = () => {
  if (userHasOptedOutOfCookiesForCategory(Consent.statistics)) {
    removeTrackerStorage()
  }
}

const decorateLink = (event: MouseEvent) => {
  if (!userHasOptedOutOfCookiesForCategory(Consent.statistics)) {
    let link = closest(event.target, 'a', true)
    if (link) {
      // for preview domains
      let isNewWindowLink =
        document.location.hostname === link.hostname && link.target === '_blank'
      // for internal domains
      let isInternalLink = allDomains
        .filter(domain => {
          return domain !== document.location.hostname
        })
        .includes(link.hostname)
      if (isInternalLink || isNewWindowLink) {
        ga('linker:decorate', link)
      }
    }
  }
}

export const manualGALinker = () => {
  if (typeof window !== 'undefined') {
    domLoaded().then(() => {
      document.body.addEventListener('click', decorateLink)
      // Aside from a normal click, we need to handle the variety of ways users
      // can open a link in a new tab
      // Right click to open context menu
      document.body.addEventListener('contextmenu', decorateLink)
      // Aside from a normal click, we need to handle the variety of ways users
      // can open a link in a new tab
      // Middle mouse button click
      document.body.addEventListener('mousedown', event => {
        if (event.button === 1) {
          decorateLink(event)
        }
      })
    })
  }
}

export const handleGAOptedOutEvent = () => {
  if (typeof window !== 'undefined') {
    window.addEventListener(
      'CookiebotOnAccept',
      handleCookiebotAcceptDeclineEvent
    )
    window.addEventListener(
      'CookiebotOnDecline',
      handleCookiebotAcceptDeclineEvent
    )
  }
}
